/**
 * @file 直播线路
 */
import { lineEnum, lineList } from '@/core/constant';
import s from '../index.module.css';
import { useEffect, useState } from 'react';

interface LineNodeProps {
  lineChecked: lineEnum; // 选中的线路
  sendHeart: (type: string, options: any) => void; // 发送心跳
  setLineChecked: (lineChecked: lineEnum) => void; // 切换选中线路
}

const LineNode = ({ sendHeart, lineChecked, setLineChecked }: LineNodeProps) => {
  const [curLine, setCurLine] = useState(lineChecked);
  const text = lineList.filter(v => v.id === curLine)?.[0]?.text;

  useEffect(() => {
    // 切换线路操作
    // 不知道为啥不能用onClick todo 下面是替代方案
    const lineArr = Array.from(document.getElementsByClassName(s.line)) as HTMLElement[];
    const lineText = document.getElementById('LineText');
    if (lineText) {
      lineText.addEventListener('click', () => {
        var pop = document.getElementById('LinePop');
        if (pop) {
          pop.style.display = 'block';
        }
      });
    }
    lineArr.map((v, idx) => {
      v.addEventListener('click', () => {
        const line = lineList[idx].id;
        sendHeart('lineChange', { line });
        setLineChecked(line);
        setCurLine(line);
        var pop = document.getElementById('LinePop');
        if (pop) {
          pop.style.display = 'none';
        }
      });
    });
  }, []);

  return (
    <div className={`xgplayer-my-line-control ${s.lineControl}`}>
      <span id="LineText" className={s.text}>
        {text}
      </span>
      <div id="LinePop" className={s.linePop}>
        {lineList.map(line => {
          return (
            <div key={line.id} className={`${s.line} ${curLine === line.id ? s.checked : ''}`}>
              {line.text}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LineNode;
